import { api } from '../api';

// Interfaces para empresa
export interface EmpresaLimitesFront {
  plano_tipo?: 'basico' | 'premium' | 'enterprise' | string;
  max_pacientes?: number;
  max_usuarios?: number;
  max_psicologos?: number;
  max_atendentes?: number;
  armazenamento_gb?: number;
  modulos?: string[];
}

export interface EmpresaQuotasFront {
  pacientes_criados?: number;
  usuarios_criados?: number;
  psicologos_criados?: number;
  atendentes_criados?: number;
}

export interface DadosEmpresa {
  id: number;
  nome: string;
  nome_fantasia?: string;
  cnpj?: string;
  email: string;
  telefone?: string;
  endereco?: string;
  cep?: string;
  cidade?: string;
  estado?: string;
  limites?: EmpresaLimitesFront;
  quotas_utilizadas?: EmpresaQuotasFront;
  logo_storage_key?: string; // ✅ NOVO
  ativo: boolean;
  created_at?: string;
  updated_at?: string;
  // Dados de assinatura e plano
  status_assinatura?: string;
  data_inicio_plano?: string;
  data_expiracao_plano?: string;
  plano_nome?: string;
  plano_slug?: string;
  plano_valor_mensal?: number;
  plano_limite_pacientes?: number;
  plano_limite_usuarios?: number;
}

export interface AtualizarEmpresaRequest {
  nome?: string;
  nome_fantasia?: string;
  cnpj?: string;
  email?: string;
  telefone?: string;
  endereco?: string;
  cep?: string;
  cidade?: string;
  estado?: string;
}

export interface ResultadoOperacao {
  sucesso: boolean;
  mensagem: string;
  dados?: any;
  erro?: string;
}

export const empresasService = {
  // Buscar dados da empresa do usuário logado
  async buscarMinhaEmpresa(): Promise<ResultadoOperacao> {
    try {
      // console.log('[EmpresasService] Buscando dados da empresa do usuário logado:', {
        // timestamp: new Date().toISOString()
      // });

      const response = await api.get('/empresas/minha-empresa');
      
      // console.log('[EmpresasService] Dados da empresa carregados:', {
        // sucesso: response.data.sucesso,
        // empresaId: response.data.dados?.id,
        // empresaNome: response.data.dados?.nome,
        // timestamp: new Date().toISOString()
      // });

      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.mensagem || error.message || 'Erro desconhecido';
      console.error('[EmpresasService] Erro ao buscar dados da empresa:', {
        error,
        errorMessage,
        status: error.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: errorMessage,
        erro: error.response?.data?.erro
      };
    }
  },

  // Atualizar dados da empresa
  async atualizarEmpresa(dados: AtualizarEmpresaRequest): Promise<ResultadoOperacao> {
    try {
      // console.log('[EmpresasService] Atualizando dados da empresa:', {
        // campos: Object.keys(dados),
        // nome: dados.nome,
        // email: dados.email,
        // timestamp: new Date().toISOString()
      // });

      const response = await api.put('/empresas/atualizar', dados);
      
      // console.log('[EmpresasService] Empresa atualizada com sucesso:', {
        // sucesso: response.data.sucesso,
        // mensagem: response.data.mensagem,
        // timestamp: new Date().toISOString()
      // });

      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.mensagem || error.message || 'Erro desconhecido';
      console.error('[EmpresasService] Erro ao atualizar empresa:', {
        error,
        errorMessage,
        status: error.response?.status,
        dados: dados,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: errorMessage,
        erro: error.response?.data?.erro
      };
    }
  },

  // Upload de logo da empresa
  async uploadLogo(arquivo: File): Promise<ResultadoOperacao> {
    try {
      console.log('[EmpresasService] Fazendo upload de logo:', {
        nomeArquivo: arquivo.name,
        tamanho: arquivo.size,
        tipo: arquivo.type,
        timestamp: new Date().toISOString()
      });

      const formData = new FormData();
      formData.append('logo', arquivo);

      const response = await api.post('/empresas/upload-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log('[EmpresasService] Logo enviada com sucesso:', {
        sucesso: response.data.sucesso,
        storageKey: response.data.dados?.storageKey,
        timestamp: new Date().toISOString()
      });

      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.mensagem || error.message || 'Erro desconhecido';
      console.error('[EmpresasService] Erro ao fazer upload de logo:', {
        error,
        errorMessage,
        status: error.response?.status,
        nomeArquivo: arquivo.name,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: errorMessage,
        erro: error.response?.data?.erro
      };
    }
  },

  // Buscar URL assinada da logo da empresa
  async buscarLogoUrl(): Promise<ResultadoOperacao> {
    try {
      const response = await api.get('/empresas/logo');
      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.mensagem || error.message || 'Erro desconhecido';
      console.error('[EmpresasService] Erro ao buscar URL da logo:', {
        error,
        errorMessage,
        status: error.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: errorMessage,
        erro: error.response?.data?.erro
      };
    }
  }
};
